import React from "react";
import { buildWhatsAppLink } from "../lib/api";

export default function WhatsAppFloat({ propertyRef = null }) {
  const msg = propertyRef
    ? `Hello WarehousesUAE, I'm interested in property ${propertyRef}. Please share more details.`
    : `Hello WarehousesUAE, I'd like to enquire about warehouse / industrial properties.`;
  return (
    <a
      href={buildWhatsAppLink(msg)}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white font-mono-tech text-xs px-4 py-3 hard-shadow"
      style={{ boxShadow: "4px 4px 0 0 #09090B" }}
    >
      <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
        <path d="M17.6 6.32A7.85 7.85 0 0 0 12.05 4a7.94 7.94 0 0 0-6.77 12.06L4 21l4.99-1.31a7.94 7.94 0 0 0 3.05.6h.01a7.94 7.94 0 0 0 7.94-7.94 7.88 7.88 0 0 0-2.39-6.03zM12.06 18.7a6.6 6.6 0 0 1-3.35-.92l-.24-.14-2.96.78.79-2.89-.16-.25a6.59 6.59 0 1 1 5.92 3.42zm3.62-4.94c-.2-.1-1.18-.58-1.36-.65-.18-.07-.31-.1-.45.1-.13.2-.51.65-.62.78-.11.13-.23.15-.43.05a5.43 5.43 0 0 1-2.7-2.36c-.2-.35.2-.32.59-1.07.06-.13.03-.25-.02-.35-.05-.1-.45-1.09-.62-1.49-.16-.39-.33-.34-.45-.34h-.39c-.13 0-.35.05-.53.25-.18.2-.7.69-.7 1.67 0 .98.71 1.93.81 2.06.1.13 1.4 2.14 3.4 3 .47.2.85.32 1.14.42.48.15.91.13 1.26.08.38-.06 1.18-.48 1.34-.95.17-.46.17-.86.12-.95-.05-.08-.18-.13-.38-.23z"/>
      </svg>
      <span className="hidden sm:inline">CHAT ON WHATSAPP</span>
    </a>
  );
}
